<template>
  <div class="container">

  </div>
</template>

<script>

export default {
  created() {

    this.$router.push("/company/" + this.$route.params.companyId + "/call");

  }
};
</script>
